var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRocket = function SvgRocket(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DD6126;}\n\t.st1{fill:#5977B8;}\n\t.st2{fill:#476292;}\n\t.st3{fill:#BC5027;}\n\t.st4{fill:#EBEBEB;}\n\t.st5{fill:#344E5C;}\n\t.st6{fill:#CDD1D3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.7,452.2c29.9-0.1,59,20,58.9,49.9c-0.1,29.9-28.6,91.7-58.5,91.8c-29.9,0.1-58.2-61.7-58.2-91.6 C244,472.4,271.8,452.2,301.7,452.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.9,280.6c69.3,24.2,123.2,188.2,66.9,182.8c-22.8-2.2-42.1-22.8-94.7-21.5c0.1,0.2,11.6-8.1,12.6-30.1 C397.9,364.8,407,280.8,406.9,280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.3,270.7c-73.5,27.7-135.9,199.5-76.8,191.8c24-3.1,44.9-25.1,99.9-25.7c-0.1,0.2-11.8-7.9-12.1-30.7 C213.6,357.5,207.1,270.9,207.3,270.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.8,287.8l-2.3,2.1c2.5,24.6,8.8,85.2,13.4,122.8c0.6,14.1,5.4,22.7,9,27c5.5-1,11.4-1.8,17.8-2.3 c-3.1-4.8-6.5-12.6-7-24.2c-5.9-48.1-14.6-133.8-14.4-134C190.7,281.2,185.2,284.2,179.8,287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M407.9,281.1c-1,12.1-8.6,88.2-13.9,132.6c-0.6,15.8-6.5,24.5-10,28.3c7.2,0,13.7,0.4,19.7,1.1 c3.3-3.2,10.2-12.1,10.8-29.2c4.4-37.2,10.4-96.3,12.8-121.8C421.2,287.3,414.6,283.6,407.9,281.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M253.4,474.8c11.4,7.3,29,12,48.9,12c19.8,0,37.3-4.7,48.8-11.9c-11-14.1-29.9-22.7-49.3-22.6 C282.3,452.2,264,460.8,253.4,474.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302,7.7c14.7-0.4,109.4,116.5,108.9,260.7c-0.3,89.3-12.8,136.2-13.7,149.5c-10.7,28.6-19,46.4-96.7,46.6 c-77.5,0.3-80.7-17.9-90.6-45c-0.8-13.6-12.9-61.1-12.6-150.4C197.8,124.9,287.1,8.6,302,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.8,199.2c25.2,0,45.6,20.5,45.6,45.6c0,25.2-20.4,45.6-45.6,45.6c-25.2,0-45.6-20.5-45.6-45.6 C256.2,219.6,276.6,199.2,301.8,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302,210.2c19.1-0.1,34.6,15.4,34.5,34.5c0,19.1-15.6,34.7-34.7,34.7c-19.1,0-34.6-15.4-34.5-34.5 C267.4,225.8,282.9,210.3,302,210.2z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRocket);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "rocket.511605781e841e78f8a8223b1816d348.svg";